"use client";
import{IntlProvider as r}from"use-intl/react";import{jsx as o}from"react/jsx-runtime";function t({locale:t,...e}){if(!t)throw new Error(void 0);return o(r,{locale:t,...e})}export{t as default};
